import ohrringeJSON from './ohrringe.json'
import kettenJSON from './ketten.json'
import armschmuckJSON from './armschmuck.json'
import manschettenknoepfeJSON from './manschettenknoepfe.json'
import ringeJSON from './ringe.json'
export const ringeDB = prepareJSONtoDB('ringe', ringeJSON.images)
export const ohrringeDB = prepareJSONtoDB('ohrringe', ohrringeJSON.images)
export const kettenDB = prepareJSONtoDB('ketten', kettenJSON.images)
export const armschmuckDB = prepareJSONtoDB('armschmuck', armschmuckJSON.images)
export const manschettenknoepfeDB = prepareJSONtoDB('manschettenknoepfe', manschettenknoepfeJSON.images)

function prepareJSONtoDB (name, images) {
  const prepImgs = images.map(image => {
    image.href = require(`@/assets/gallery/imgs/${name.toLowerCase()}/${image.imgName}`)
    return image
  })
  return prepImgs
}
